import { C, D } from './include'
import { Layers, ViewList, Equalizer, NetworkCheck, Computer, ThreeSixty, Build, Person, Lock, SupervisedUserCircle, Face, SettingsSuggest, Handyman, Loyalty, ConnectWithoutContact, WhatsApp, ContactMail } from '@mui/icons-material'
import { Dashboard } from './views/Dashboard'
import { Servers } from './views/Servers'
import { Daemons } from './views/Daemons'
import { SysConfig } from './views/SysConfig'
import { Users } from './views/Users'
import { Permissions } from './views/Permissions'
import { AccessProfile } from './views/AccessProfile'
import { MyProfile } from './views/MyProfile'
import { Company } from './views/Company'
import { Logs } from './views/Logs'
import { Choice } from './views/Choice'
import { Question } from './views/Question'
import { Questionnaire } from './views/Questionnaire'
import { File } from './views/File'
import { Doctor } from './views/Doctor'
import { Treatment } from './views/Treatment'
import { Patient } from './views/Patient'
import { Utils } from './views/Utils'
import { MedicalRecord } from './views/MedicalRecord'
import { Document } from './views/Document'
import { TicketIn } from './views/TicketIn'
import { WhatsAppManager } from './views/Whatsapp'
import { EmailManager } from './views/Email'


export const navigation = [
  {
    id: 'patient',
    title: 'Paciente',
    type: 'item',
    icon: <Face sx={{ color: '#fff' }} />,
    component: <Patient />,
    url: '/patient',
    permission: 'Paciente-Ler',
  },
  {
    id: 'ticketin',
    title: 'Ticket de Entrada',
    type: 'item',
    icon: <Loyalty sx={{ color: '#fff' }} />,
    component: <TicketIn />,
    url: '/ticketin',
    permission: 'Ticket-Ler',
  },
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'item',
    icon: <Equalizer sx={{ color: '#fff' }} />,
    component: <Dashboard />,
    url: '/dashboard',
    permission: 'Dashboard-Ler',
  },
  {
    id: 'register',
    title: 'Cadastros',
    type: 'collapse',
    icon: <ViewList sx={{ color: '#fff' }} />,
    permission: 'Cadastro-Ler',
    children: [
      {
        id: 'file',
        title: 'Arquivo',
        type: 'item',
        icon: <ViewList sx={{ color: '#fff' }} />,
        component: <File />,
        url: '/file',
        permission: 'Arquivo-Ler',
      },
      {
        id: 'document',
        title: 'Documento',
        type: 'item',
        icon: <ViewList sx={{ color: '#fff' }} />,
        component: <Document />,
        url: '/document',
        permission: 'Documento-Ler',
      },
      {
        id: 'company',
        title: C.companyLabel,
        type: 'item',
        icon: <ViewList sx={{ color: '#fff' }} />,
        component: <Company />,
        url: '/company',
        permission: 'Empresa-Ler',
      },
      {
        id: 'choice',
        title: 'Escolha',
        type: 'item',
        icon: <ViewList sx={{ color: '#fff' }} />,
        component: <Choice />,
        url: '/choice',
        permission: 'Escolha-Ler',
      },
      {
        id: 'question',
        title: 'Pergunta',
        type: 'item',
        icon: <ViewList sx={{ color: '#fff' }} />,
        component: <Question />,
        url: '/question',
        permission: 'Pergunta-Ler',
      },
      {
        id: 'doctor',
        title: 'Profissional de Saúde',
        type: 'item',
        icon: <ViewList sx={{ color: '#fff' }} />,
        component: <Doctor />,
        url: '/doctor',
        permission: 'Doutor-Ler',
      },
      {
        id: 'questionnaire',
        title: 'Questionário',
        type: 'item',
        icon: <ViewList sx={{ color: '#fff' }} />,
        component: <Questionnaire />,
        url: '/questionnaire',
        permission: 'Questionario-Ler',
      },
      {
        id: 'treatment',
        title: 'Tratamento',
        type: 'item',
        icon: <ViewList sx={{ color: '#fff' }} />,
        component: <Treatment />,
        url: '/treatment',
        permission: 'Tratamento-Ler',
      },
    ]
  },
  {
    id: 'administration',
    title: 'Administração',
    type: 'collapse',
    icon: <SettingsSuggest sx={{ color: '#fff' }} />,
    permission: 'Administracao-Ler',
    children: [
      {
        id: 'user',
        title: 'Usuários',
        type: 'item',
        icon: <Person sx={{ color: '#fff' }} />,
        component: <Users />,
        url: '/user',
        permission: 'Usuário-Ler',
      },
      {
        id: 'permission',
        title: 'Permissões',
        type: 'item',
        icon: <Lock sx={{ color: '#fff' }} />,
        component: <Permissions />,
        url: '/permission',
        permission: 'Permissão-Ler',
      },
      {
        id: 'access-profile',
        title: 'Perfis de Acesso',
        type: 'item',
        icon: <SupervisedUserCircle sx={{ color: '#fff' }} />,
        component: <AccessProfile />,
        url: '/access-profile',
        permission: 'Perfil de Acesso-Ler',
      },
      {
        id: 'util',
        title: 'Utilitários',
        type: 'item',
        icon: <Handyman sx={{ color: '#fff' }} />,
        component: <Utils />,
        url: '/utils',
        permission: 'Utilitario-Ler',
      },
    ]
  },
  {
    id: 'comercial',
    title: 'Comercial',
    type: 'collapse',
    icon: <ConnectWithoutContact sx={{ color: '#fff' }} />,
    permission: 'Comercial-Ler',
    children: [
      {
        id: 'whatapp',
        title: 'WhatsApp',
        type: 'item',
        icon: <WhatsApp sx={{ color: '#fff' }} />,
        component: <WhatsAppManager />,
        url: '/whatsapp',
        permission: 'Whatsapp-Ler',
      },
      {
        id: 'email',
        title: 'Email',
        type: 'item',
        icon: <ContactMail sx={{ color: '#fff' }} />,
        component: <EmailManager />,
        url: '/email',
        permission: 'Email-Ler',
      },
    ]
  },
  {
    id: 'controlpanel',
    title: 'Painel de Controle',
    type: 'collapse',
    icon: <NetworkCheck sx={{ color: '#fff' }} />,
    permission: 'Painel de Controle-Ler',
    children: [
      {
        id: 'equipment',
        title: 'Equipamentos',
        type: 'item',
        icon: <Computer sx={{ color: '#fff' }} />,
        component: <Servers />,
        url: '/server',
        permission: 'Equipamento-Ler',
      },
      {
        id: 'daemons',
        title: 'Daemons',
        type: 'item',
        icon: <ThreeSixty sx={{ color: '#fff' }} />,
        component: <Daemons />,
        url: '/daemons',
        permission: 'Daemon-Ler',
      },
      {
        id: 'sysconfig',
        title: 'Configurações do Sistema',
        type: 'item',
        icon: <Build sx={{ color: '#fff' }} />,
        component: <SysConfig />,
        url: '/sysconfig',
        permission: 'Config. Sistema-Ler',
      },
      {
        id: 'logs',
        title: 'Logs de acesso',
        type: 'item',
        icon: <Layers sx={{ color: '#fff' }} />,
        component: <Logs />,
        url: '/logs',
        permission: 'Equipamento-Ler',
      }
    ]
  },
  {
    id: 'myprofile',
    title: 'Meu Perfil',
    type: 'route',
    icon: null,
    component: <MyProfile />,
    url: '/profile',
    permission: 'Usuário-Ler'
  },
  {
    id: 'logout',
    title: 'Sair',
    type: 'route',
    icon: null,
    component: <D />,
    url: '/logout',
    permission: ''
  },
  {
    id: 'medicalrecord',
    title: 'Prontuário',
    type: 'route',
    icon: null,
    component: <MedicalRecord />,
    url: '/medicalrecord',
    permission: 'Prontuário-Escrever'
  }
]
